module.exports = __webpack_public_path__ + "img/pillows.1664be9.svg";